var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.82,20c0.065,0 0.13,-0.01 0.196,-0.03c0.065,-0.02 0.123,-0.042 0.175,-0.069l3.34,-1.677a0.934,0.934 0 0 0 0.342,-0.315a0.786,0.786 0 0 0 0.127,-0.434l0,-4.715l4.512,-4.558a1.678,1.678 0 0 0 0.488,-1.182l0,-2.17a0.823,0.823 0 0 0 -0.244,-0.602a0.807,0.807 0 0 0 -0.596,-0.248l-13.34,0a0.784,0.784 0 0 0 -0.576,0.247a0.823,0.823 0 0 0 -0.244,0.601l0,2.17a1.68,1.68 0 0 0 0.488,1.184l4.512,4.558l0,6.392c0,0.144 0.033,0.28 0.098,0.404a0.772,0.772 0 0 0 0.293,0.306c0.065,0.04 0.133,0.072 0.205,0.099c0.071,0.026 0.146,0.039 0.224,0.039zm0.84,-2.21l0,-5.366c0,-0.118 -0.02,-0.23 -0.058,-0.335a0.635,0.635 0 0 0 -0.105,-0.184l-4.837,-4.886l0,-1.342l11.66,0l0,1.342l-4.746,4.813a0.683,0.683 0 0 0 -0.185,0.257a0.834,0.834 0 0 0 -0.069,0.335l0,4.518l-1.66,0.848z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filterIcon-inner",
    fill: "transparent",
    d: "m11.66,17.79l0,-5.366c0,-0.118 -0.02,-0.23 -0.058,-0.335a0.635,0.635 0 0 0 -0.105,-0.184l-4.837,-4.886l0,-1.342l11.66,0l0,1.342l-4.746,4.813a0.683,0.683 0 0 0 -0.185,0.257a0.834,0.834 0 0 0 -0.069,0.335l0,4.518l-1.66,0.848z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};

export default SvgFilter;